// 全站统一错误码
// https://km.sankuai.com/collabpage/1701608092

// 账号未登录，无token等，passport/sso校验结果
// 401~406都表示未登录
const LOGIN_ERROR_401 = 401;
const LOGIN_ERROR_402 = 402;
const LOGIN_ERROR_403 = 403;
const LOGIN_ERROR_404 = 404;
const LOGIN_ERROR_405 = 405;
const LOGIN_ERROR_406 = 406;

// 账号未登录，无token等，shepherd校验无token
const LOGIN_ERROR_SSO_NOTOKEN = 50102;

// 账号未登录，无token等，shepherd校验无token
const LOGIN_ERROR_PASSPORT_NOTOKEN = 50103;

// 账号未登录，无token等，shepherd校验鉴权组件请求超时
const LOGIN_ERROR_SHEPHERD_TIMEOUT = 5001;

// 账号未登录，无token等，shepherd校验token为空(23年5月新升级后)
const LOGIN_ERROR_SHEPHERD_NOTOKEN = 5002;

// 账号不存在：
const LOGIN_ERROR_ACCOUNT_NOT_EXIST = 101000;

// 商家端账号关联门店不匹配越权，后端shepherd组件统一拦截码
// 商家账号、门店越权，单独处理：https://km.sankuai.com/collabpage/1692195427
// {"code":130000100,"message":"No  permission,account and shop relationship does not correspond."}
// 特殊逻辑：
// 单门店账号：门店已失效，请重新登录
// 多门店账号：门店已失效，请重新选择门店
// 多门店账号，没有可用门店：未关联门店，请关联门店
const NO_PERMISSION_OF_SHOP = 130000100;

// M端嵌入商家端页面，门店越权，后端shepherd组件统一拦截码
// {"code":140000000,"message":"No  permission."}
const M_NO_PERMISSION_PARAMS_ERROR = 140000000;

// M端嵌入商家端页面，品牌关联的门店越权，后端shepherd组件统一拦截码
// {"code":141000100,"message":"No  permission."}
const M_NO_PERMISSION = 141000100;

// 直接跳登录页到的处理（不刷新页面，不重新登录的情况都直接跳登录）。
// 其他情况可透传给业务代码，自行弹窗。
const LOGIN_ERROR_CODES = [
  LOGIN_ERROR_401,
  LOGIN_ERROR_402,
  // TODO： temp - guard异常问题 排查
  // LOGIN_ERROR_403,
  LOGIN_ERROR_404,
  LOGIN_ERROR_405,
  LOGIN_ERROR_406,
  LOGIN_ERROR_SSO_NOTOKEN,
  LOGIN_ERROR_PASSPORT_NOTOKEN,
  LOGIN_ERROR_SHEPHERD_NOTOKEN,
];

// 提示后-跳登录页到的处理（不刷新页面，不重新登录的情况都直接跳登录）。
// 其他情况可透传给业务代码，自行弹窗。
const LOGIN_ERROR_TOAST_EXIT_CODES = [
  LOGIN_ERROR_ACCOUNT_NOT_EXIST,
];

// 只弹窗提示的账号、权限问题
const LOGIN_ERROR_TOAST_ONLY_CODES = [
  LOGIN_ERROR_SHEPHERD_TIMEOUT,
  M_NO_PERMISSION_PARAMS_ERROR,
  M_NO_PERMISSION,
];

const LOGIN_ERROR_APP_ACTION_CODES = [
  LOGIN_ERROR_401,
  LOGIN_ERROR_402,
  LOGIN_ERROR_403,
  LOGIN_ERROR_404,
  LOGIN_ERROR_405,
  LOGIN_ERROR_406,
  LOGIN_ERROR_SHEPHERD_TIMEOUT,
  LOGIN_ERROR_SHEPHERD_NOTOKEN,
  NO_PERMISSION_OF_SHOP,
];

export {
  LOGIN_ERROR_401,
  LOGIN_ERROR_402,
  LOGIN_ERROR_403,
  LOGIN_ERROR_404,
  LOGIN_ERROR_405,
  LOGIN_ERROR_406,
  LOGIN_ERROR_SSO_NOTOKEN,
  LOGIN_ERROR_PASSPORT_NOTOKEN,
  LOGIN_ERROR_SHEPHERD_TIMEOUT,
  LOGIN_ERROR_SHEPHERD_NOTOKEN,
  LOGIN_ERROR_ACCOUNT_NOT_EXIST,
  NO_PERMISSION_OF_SHOP,
  M_NO_PERMISSION_PARAMS_ERROR,
  M_NO_PERMISSION,
  LOGIN_ERROR_CODES,
  LOGIN_ERROR_TOAST_EXIT_CODES,
  LOGIN_ERROR_TOAST_ONLY_CODES,
  LOGIN_ERROR_APP_ACTION_CODES,
};
